import { generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DayTripPlanI18nEditContainer } from "@/components/features/items/edit/plan/day-trip/i18n/ui/existing/container";

import { useGetPlanI8nEditPageParams } from "./_hooks/use-get-plan-i18n-edit-page-params";

export const ExistingDayTripPlanI18nEditPage = () => {
	const { hotelID, planID, langCode } = useGetPlanI8nEditPageParams();

	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.DEFAULT, { hotelID, planID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.I18N, { hotelID, planID, langCode }),
	};

	return (
		<PageMeta
			title="日帰りプランの編集"
			url={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.I18N, { hotelID, planID, langCode })}
		>
			<DayTripPlanI18nEditContainer
				hotelID={hotelID}
				planID={planID}
				activeLangCode={langCode}
				navigator={navigator}
			/>
		</PageMeta>
	);
};

ExistingDayTripPlanI18nEditPage.displayName = "ExistingDayTripPlanI18nEditPage";
